import { useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="home">
      <Navbar />

      <div className="customer-page">
        <div className="customer-page-header">
          <h2>About Us</h2>
          <p>Authentic Taste of Surat, Delivered to Your Doorstep</p>
        </div>

        <section className="customer-card settings-section">
          <h3>Our Story</h3>
          <p>
            Shreeji Surti Swad is more than just a food delivery app—it's a celebration of Surat's authentic cuisine. 
            Born from a passion to bring traditional Gujarati and Surati flavors to your table, we've built a platform 
            that connects you with the best local restaurants and food entrepreneurs.
          </p>
          <p>
            Since our inception, we've been committed to delivering fresh, quality food with exceptional service. 
            Every order is prepared with care, and every delivery is made with pride.
          </p>
        </section>

        <section className="customer-card settings-section">
          <h3>Our Mission</h3>
          <p>
            To celebrate and promote authentic Gujarati cuisine while creating convenient food delivery experiences 
            for every corner of Mumbai. We believe in supporting local businesses and bringing communities closer through food.
          </p>
        </section>

        <section className="customer-card settings-section">
          <h3>Why Choose Us?</h3>
          <div className="about-features">
            <article className="feature-card">
              <h4>🍴 Authentic Taste</h4>
              <p>Traditional recipes prepared with fresh ingredients</p>
            </article>
            <article className="feature-card">
              <h4>⚡ Quick Delivery</h4>
              <p>Orders before 10 PM delivered next day morning</p>
            </article>
            <article className="feature-card">
              <h4>👥 Local Support</h4>
              <p>Supporting local restaurants and small businesses</p>
            </article>
            <article className="feature-card">
              <h4>💚 Quality First</h4>
              <p>Every item quality checked before dispatch</p>
            </article>
          </div>
        </section>

        <section className="customer-card settings-section">
          <h3>Service Areas</h3>
          <p>We currently operate in these Mumbai neighborhoods:</p>
          <div className="service-areas">
            <span className="area-badge">🌆 Malad</span>
            <span className="area-badge">🌆 Kandivali</span>
            <span className="area-badge">🌆 Borivali</span>
            <span className="area-badge">🌆 Dahisar</span>
          </div>
          <p style={{ marginTop: "1.5rem", fontSize: "0.9rem", opacity: 0.7 }}>
            Expanding across Mumbai soon! Request service in your area through the Partner with Us program.
          </p>
        </section>

        <section className="customer-card settings-section">
          <h3>Contact Us</h3>
          <div className="contact-info">
            <p><strong>📧 Email:</strong> shreejisurtiswad@gmail.com</p>
            <p><strong>📱 Phone:</strong> +91-7977788566</p>
            <p><strong>⏰ Operating Hours:</strong> 7:00 AM - 11:00 PM Daily</p>
          </div>
          <div className="page-actions" style={{ marginTop: "1.5rem" }}>
            <button className="primary-action" onClick={() => navigate("/support")}>
              Go to Support
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
